import * as THREE from 'three';
import { PLANET_R } from '../config.js';

// A scattering of small glowing motes that drift slowly around fixed home
// points near the surface. With scene fog on, distant fireflies fade out, so
// only a handful are visible at once — a soft layer of ambient life.

const fireflies = [];
const _offset = new THREE.Vector3();

export function createFireflies(scene, count = 90) {
  // One shared geometry, but each firefly gets its own material so we can
  // vary opacity independently for the pulse.
  const geometry = new THREE.SphereGeometry(0.045, 8, 6);
  for (let i = 0; i < count; i++) {
    const material = new THREE.MeshBasicMaterial({
      color: 0xfff0a6,
      transparent: true,
      opacity: 0.7,
      blending: THREE.AdditiveBlending,
      depthWrite: false,
    });
    const mesh = new THREE.Mesh(geometry, material);

    const dir = new THREE.Vector3().randomDirection();
    const home = dir.clone().multiplyScalar(PLANET_R + 0.7 + Math.random() * 1.5);
    mesh.position.copy(home);
    scene.add(mesh);

    fireflies.push({
      mesh,
      home,
      phase: Math.random() * Math.PI * 2,
      speed: 0.9 + Math.random() * 0.6,
    });
  }
}

export function updateFireflies() {
  const t = performance.now() / 1000;
  for (const f of fireflies) {
    const p = f.phase;
    const s = f.speed;
    // Lissajous-ish drift around the home position — smooth, bounded,
    // and different per firefly because of phase and speed jitter.
    _offset.set(
      Math.sin(t * 0.4 * s + p)        * 0.7,
      Math.sin(t * 0.7 * s + p * 2.1)  * 0.45,
      Math.cos(t * 0.55 * s + p * 1.7) * 0.7,
    );
    f.mesh.position.copy(f.home).add(_offset);

    // Soft pulse — mostly on, with occasional dimming rather than blinking off.
    const pulse = 0.45 + 0.55 * Math.max(0, Math.sin(t * 1.2 * s + p * 3));
    f.mesh.material.opacity = pulse;
  }
}
